import React, { useMemo } from 'react';
import { useTheme } from '../context/ThemeContext';

const ThemeDevSwitcher = ({ inline = true }) => {
  const { theme, setTheme, themes } = useTheme();

  const cycleTheme = () => {
    const idx = themes.indexOf(theme);
    const next = themes[(idx + 1 + themes.length) % themes.length];
    setTheme(next);
  };

  const containerStyle = useMemo(() => {
    if (inline) {
      return {
        display: 'flex',
        gap: '6px',
        alignItems: 'center',
        fontSize: '12px',
      };
    }
    return {
      position: 'fixed',
      bottom: '12px',
      right: '12px',
      display: 'flex',
      gap: '6px',
      alignItems: 'center',
      padding: '8px 10px',
      borderRadius: '8px',
      border: '1px solid var(--border-low-color, #d0d7de)',
      background: 'var(--surface-low-color, #ffffff)',
      boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
      zIndex: 1000,
      fontSize: '12px',
    };
  }, [inline]);

  const btnStyle = inline
    ? {
        cursor: 'pointer',
      }
    : {
        padding: '4px 8px',
        borderRadius: '6px',
        border: '1px solid var(--border-low-contrast)',
        background: 'var(--card-bg)',
        color: 'var(--card-text)',
        cursor: 'pointer',
      };

  // Render for members-only via Layout; allow in all environments.

  return (
    <div style={containerStyle} aria-label="Theme switcher">
      {inline ? (
        <>
          <button className="theme-toggle" style={btnStyle} onClick={cycleTheme} title="Cycle themes">
            {(theme || '').toUpperCase()}
          </button>
        </>
      ) : (
        <>
          {themes.map((t) => (
            <button
              key={t}
              style={{
                ...btnStyle,
                fontWeight: t === theme ? 700 : 500,
                textDecoration: t === theme ? 'underline' : 'none',
              }}
              onClick={() => setTheme(t)}
            >
              {t.toUpperCase()}
            </button>
          ))}
          <button style={btnStyle} onClick={cycleTheme} title="Cycle themes">
            NEXT
          </button>
        </>
      )}
    </div>
  );
};

export default ThemeDevSwitcher;
